import {Injectable} from "@angular/core";
import {CssSentence, CssWord, ContentCssClass} from "../../content/content-view.objects";
import {IReadingMode} from "../../reading/reading.component";
import {ContentCursor, AllowedSelectionType} from "../content/content.cursor";
import {QuestionService} from "../question/question.service";
import {CompletionState, QuestionState} from "../usermodel/usermodel.objects";
import {UserModelService} from "../usermodel/usermodel.service";
import {StepStateUpdater} from "../step/step-state";
import {AudioQueueService} from "../audio-playback/audioqueue.service";

@Injectable()
export class QuizService implements IReadingMode {

    private quizActive: boolean;

    constructor(private audioQueueService: AudioQueueService,
                private userModelService: UserModelService,
                private contentCursor: ContentCursor,
                private stepStateUpdater: StepStateUpdater,
                private questionService: QuestionService) {
    }

    sentenceFinishedCallback: Function;

    public startWord(wordItem: CssWord): void {
    }

    public startSentence(sentenceItem: CssSentence, callback: Function): void {
    }

    public activate(isPipeline: boolean): void {
        this.contentCursor.setMode(ContentCssClass.MODE_QUIZ);
    }

    public pause(): void {
        this.audioQueueService.hardReset();
    }

    public get changeUIWhenActive(): boolean {
        return false;
    }

    public get allowedSelectionType(): AllowedSelectionType {
        return AllowedSelectionType.SENTENCE;
    }

    /**
     * Which question will we start with, when starting/resuming the quiz?
     */
    public get startingQuestionId(): number {
        // lastQuizId is the last question answered but it is one-based, while startingQuestionId is zero-based,
        // so we don't have to add one in this case
        return this.userModelService.lastQuizId < this.questionService.retrieveQuiz().length ?
               this.userModelService.lastQuizId : 0;
    }

    public setQuizActive(quizActive: boolean): void {
        this.quizActive = quizActive;
    }

    /**
     * Label to show in UI, based on quiz completion status
     */
    public get quizButtonLabel(): string {
        if (this.quizActive) {
            return "Continue";
        }
        if (this.stepStateUpdater.isStepCompleted(this.userModelService.quizCompletionState)) {
            return "Retake";
        }
        if (this.startingQuestionId > 0 ||
            this.userModelService.quizCompletionState === CompletionState.INCOMPLETE) {
            return "Continue";
        }
        return "Start";
    }

    public isQuizActive():boolean {
      return this.quizActive;
    }
}
